export default __webpack_public_path__ + "static/product_category_software-b9f35eca1f3645868195c753364a5c03.jpg";